/**
 * Empty state (design-system §7 · Empty state): icono Lucide 40 px en círculo coral suave,
 * título 18 px/600, texto 14 px y, opcionalmente, una acción primaria compacta.
 */
import { Inbox, type LucideIcon } from 'lucide-react';

import { cn } from '../../lib/cn';

import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title,
  description,
  icon: Icon = Inbox,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-fm-3 rounded-fm-lg border border-fm-border bg-fm-surface p-fm-10 text-center',
        className,
      )}
    >
      <span className="flex size-fm-control-lg items-center justify-center rounded-fm-pill bg-fm-primary-soft">
        <Icon size={40} className="text-fm-primary-text" aria-hidden="true" />
      </span>
      <h3 className="font-display text-fm-lg font-semibold text-fm-text">{title}</h3>
      {description ? (
        <p className="max-w-prose text-fm-sm text-fm-text-secondary">{description}</p>
      ) : null}
      {action}
    </div>
  );
}
